import RouteConfig from './routeConfig';

export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

const VERSION_PROJECT = {
  // eslint-disable-next-line global-require
  version: require('../../package.json').version,
};

export { VERSION_PROJECT, RouteConfig };
